<template>
  <div class="analzholder">
    <div>
      <svg viewbox="0 0 80 80" class="myBrain">
        <path
          d="M 35 38 L 28 43 L 24 38 L 16 42 L 8 39 L 6 31 L 13 31 L 18 24 L 5 24 L 11 16 L 14 20 L 18 11 L 32 5 L 20 18 L 31 12 L 38 5 L 50 5 L 39 12 L 35 22 L 30 18 L 23 23 L 17 35 L 26 32 L 26 28 L 30 24 L 31 34 L 38 31 L 35 27 L 42 23 L 43 33 L 48 31 L 44 17 L 47 13 L 51 25 L 58 20 L 50 10 L 59 9 L 59 15 L 63 12 L 63 18 L 69 17 L 74 26 L 67 21 L 58 25 L 53 34 L 42 38 L 42 42 L 27 48 L 32 51 L 39 48 L 48 46 L 51 41 L 56 42 L 56 37 L 62 35 L 61 29 L 68 29 L 73 32 L 72 39 L 74 45 L 72 55 L 67 52 L 68 46 L 67 36 L 63 40 L 57 47 L 48 53 L 39 53 L 35 57 L 44 59 L 56 54 L 62 48 L 63 56 L 67 57 L 61 60 L 54 59 L 51 64 L 56 64 L 53 69 L 58 71 L 55 76"
          fill="none" stroke="#16a085" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" />
      </svg>
    </div>
    <div class="content">
      <div class="content__container">
        <ul class="content__container__list" v-if="isDynamic==0">
          <li class="content__container__list__item">Analyzing Data</li>
          <li class="content__container__list__item">Crunching the Numbers</li>
          <li class="content__container__list__item">Running the Models</li>
          <li class="content__container__list__item">Generating Insights</li>
        </ul>
        <ul class="content__container__list" v-if="isDynamic==1">
          <li class="content__container__list__item">Analyzing Data</li>
          <li class="content__container__list__item">Validating Columns</li>
          <li class="content__container__list__item">Validating Data Type</li>
          <li class="content__container__list__item">Validating Data Format</li>          
        </ul>
        <ul class="content__container__list" v-if="isDynamic==2">
          <li class="content__container__list__item">Analyzing Data</li>
          <li class="content__container__list__item">Writing into DB</li>
          <li class="content__container__list__item">Generating Data Quality</li>
          <li class="content__container__list__item">Generating Suggestions</li>          
        </ul>
        <ul class="content__container__list" v-if="isDynamic==3">
          <li class="content__container__list__item">Analyzing Data</li>
          <li class="content__container__list__item">Storing Data</li>
          <li class="content__container__list__item">Generating PPR</li>
          <li class="content__container__list__item">Setting up Dashboard</li>          
        </ul>        
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'analzerLoaderComp',
    props: {},
    data(){
      return{
        isDynamic: 0,
      }
    },
    methods: {
      setValuesVal(){
        this.isDynamic = 1
      },
      setValuesDQ(){
        this.isDynamic = 2
      },
      setAPPMRule(){
        this.isDynamic = 3
      }  
    }
  }
</script>

<style scoped>
  .analzholder {
    position: fixed;
    height: 120px;
    width: 400px;
    line-height: 35px;
    color: #ecf0f1;
    margin: auto;
    top: calc(50% - 175px);
    left: calc(50% - 175px);
  }

  .content {
    position: relative;
    margin-top: -75px;
    box-shadow: 0px 0px 8px -1px #a0a0a0;
    border-radius: 5px;
  }

  .darkTheme .content {
    box-shadow: 0px 0px 8px -1px #2c2c2c;
  }

  .content__container {
    font-weight: 600;
    overflow: hidden;
    height: 40px;
    padding: 2px 35px;
    background-color: #bdbdbd;
    box-shadow: 0 0 1px 4px #333;
  }


  .darkTheme .content__container {
    background-color: #535353
  }

  .content__container:before {
    content: "[";
    left: 2px
  }

  .content__container:after {
    content: "]";
    right: 2px
  }

  .content__container:after,
  .content__container:before {
    position: absolute;
    top: 0;
    color: #CC5500;
    /* font-size: 20pt; */
    line-height: 42px;
    -webkit-animation-name: opacity;
    -webkit-animation-duration: 2s;
    -webkit-animation-iteration-count: infinite;
    animation-name: opacity;
    animation-duration: 2s;
    animation-iteration-count: infinite
  }

  .content__container__list {
    color: #CC5500;
    margin-top: 0;
    text-align: center;
    list-style: none;
    -webkit-animation-name: change;
    -webkit-animation-duration: 10s;
    -webkit-animation-iteration-count: infinite;
    animation-name: change;
    animation-duration: 10s;
    animation-iteration-count: infinite
  }

  .darkTheme .content__container__list,
  .darkTheme .content__container:after,
  .darkTheme .content__container:before {
    color: #ecc257;
  }

  .content__container__list__item {
    line-height: 35px;
    margin: 0 0 0 -35px
  }

  .myBrain {
    height: 150px;
    width: 150px;
    margin-left: 150px;
    margin-bottom: 20px;
  }

  .myBrain path {
    stroke-dasharray: 670;
    stroke-dashoffset: 670;
    animation: dashBrain 4s linear infinite;
    stroke: #1e7895;
  }

  .darkTheme .myBrain path {
    stroke: #5bdfe3;
  }

  @keyframes dashBrain {
    0% {
      opacity: 1;
    }

    80% {
      stroke-dashoffset: 0;
      opacity: 1;
    }

    90% {
      stroke-dashoffset: 0;
      opacity: 1
    }

    100% {
      stroke-dashoffset: 0;
      opacity: 0;
    }
  }
</style>